// This file contains the data for the webinars page.
// The data is grouped between the upcoming webinars and recorded webinars.
// - Upcoming webinars are ordered by date, from the closest upcoming to the furthest away.
// - Recorded webinars are ordered by date, from the most recent to the oldest.
// Each webinar object contains the following required properties:
// - Upcoming: Title, date, time, vertical, topic, registrationUrl, brandLogo, and details.
// - Recorded: Title, date, vertical, topic, recordingUrl, and details.
// When a webinar is recorded, move it to the recorded webinars section and add the recordingUrl.

const webinars = [
  // start of upcoming webinars
  // order from the closest upcoming to the furthest away
  {
    title: 'Ensuring Safety and Compliance in the Mining Industry',
    date: 'July 11, 2025',
    time: '11:00AM CST',
    vertical: ['Workplace Safety'],
    topic: ['Industrial Safety and Health'],
    registrationUrl: 'https://attendee.gotowebinar.com/register/4074480475117536853',
    id: '4074480475117536853',
    recordingUrl: null,
    brandLogo: 'osha-education-center-logo.png',
    details: `
      <p>Join Certus and OSHA Education Center for this free public one-hour webinar where we will discuss the unique challenges of the mining industry. Topics include:</p>
      <ul>
        <li>Discussing the unique risks and hazards within a mining environment</li>
        <li>Understanding MSHA and its application in the modern workplace</li>
        <li>How to ensure safety for workers at expansive work sites</li>
      </ul>
    `,
  },
  {
    title: 'Tools for Success for a High School or College Vocational Program',
    date: 'August 8, 2025',
    time: '11:00AM CST',
    vertical: ['Industrial Skills', 'Professional Services'],
    topic: ['Training Best Practices, Automotive'],
    registrationUrl: 'https://attendee.gotowebinar.com/register/6888431996782382684',
    id: '6888431996782382684',
    recordingUrl: null,
    brandLogo: 'sp2-logo.png',
    details: `
      <p>Join Certus and S/P2 for this free public one-hour webinar where we will discuss toolkits for instructors in the classroom. Topics include:</p>
      <ul>
        <li>When to use 3rd-party tools to aid the classroom experience. Pros and cons</li>
        <li>Learning management with web-based software to ensure consistent student monitoring each semester</li>
        <li>Tools for homework, review, testing, and lab exercises</li>
      </ul>
    `,
  },
  {
    title: 'How to have a Winning Maintenance Team in the Manufacturing Sector',
    date: 'October 10, 2025',
    time: '11:00AM CST',
    vertical: ['Industrial Skills', 'Workplace Safety'],
    topic: [
      'Electrical Skills',
      'HVAC Skills',
      'Mechanical Skills',
      'Industrial Safety and Health',
      'Training Best Practices',
    ],
    registrationUrl: 'https://attendee.gotowebinar.com/register/3084723197537842782',
    id: '3084723197537842782',
    recordingUrl: null,
    brandLogo: 'TPC-pauson-logo.png',
    details: `
      <p>Join Certus, Paulson, and TPC for this free public one-hour webinar where we will discuss how to develop a superstar team of maintenance technicians in a manufacturing environment. Topics include:</p>
      <ul>
        <li>Understanding the cost/impact of downtime</li>
        <li>Universal skills and knowledge that technicians must possess</li>
        <li>How to ensure training and safety in a fast-paced demanding production environment</li>
      </ul>
    `,
  },
  {
    title: 'Employee Development for the Food and Beverage Industry',
    date: 'December 12, 2025 ',
    time: '11:00AM CST',
    vertical: ['Seller Server'],
    topic: ['Food Safety'],
    registrationUrl: 'https://attendee.gotowebinar.com/register/4687775966463209048',
    id: '4687775966463209048',
    recordingUrl: null,
    brandLogo: 'statefoodsafety-logo.png',
    details: `
      <p>Join Certus and StateFoodSafety for this free public one-hour webinar where we will discuss how to develop employee skills within a food and beverage industry environment. Topics include:</p>
      <ul>
        <li>What is food handler and food manager training?  Who needs it?</li>
        <li>HACCP and its application in food manufacturing</li>
        <li>Safety and maintenance concerns specific to the food manufacturing industry</li>
      </ul>
    `,
  },

  // start of recorded webinars
  // order from the most recent to the oldest
  {
    title: 'SkillUpAmerica Summit: Level Up Summer Youth Outcomes with Games',
    date: 'April 24, 2025',
    time: null,
    vertical: ['Professional Services', 'Workforce Development'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078821862',
    brandLogo: null,
    details: `
      <p>Workforce180 and Metrix Learning free 2-day conference.</p>
    `,
  },
  {
    title: "SkillUpAmerica Summit: Managing and Motivating in Today's Workforce World",
    date: 'April 24, 2025',
    time: null,
    vertical: ['Professional Services', 'Workforce Development'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078822390',
    brandLogo: null,
    details: `
      <p>Workforce180 and Metrix Learning free 2-day conference.</p>
    `,
  },
  {
    title: 'SkillUpAmerica Summit: Future-Proofing Workforce: Strategic Planning with Measurable Results',
    date: 'April 24, 2025',
    time: null,
    vertical: ['Professional Services', 'Workforce Development'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078823541',
    brandLogo: null,
    details: `
      <p>Workforce180 and Metrix Learning free 2-day conference.</p>
    `,
  },
  {
    title:
      'SkillUpAmerica Summit: Mobile Technology Fills Big Communication Gaps in Times of Funding and Staffing Uncertainty',
    date: 'April 24, 2025',
    time: null,
    vertical: ['Professional Services', 'Workforce Development'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078823887',
    brandLogo: null,
    details: `
      <p>Workforce180 and Metrix Learning free 2-day conference.</p>
    `,
  },
  {
    title: 'SkillUpAmerica Summit: Apprenticeships in Action',
    date: 'April 23, 2025',
    time: null,
    vertical: ['Professional Services', 'Workforce Development'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078823332',
    brandLogo: null,
    details: `
      <p>Workforce180 and Metrix Learning free 2-day conference.</p>
    `,
  },
  {
    title: 'SkillUpAmerica Summit: Are Degrees Useless? Employers Want Skills',
    date: 'April 23, 2025',
    time: null,
    vertical: ['Professional Services', 'Workforce Development'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078823416',
    brandLogo: null,
    details: `
      <p>Workforce180 and Metrix Learning free 2-day conference.</p>
    `,
  },
  {
    title: 'SkillUpAmerica Summit: Behind the Data: In-Demand Skills, Tools, and Technology',
    date: 'April 23, 2025',
    time: null,
    vertical: ['Professional Services', 'Workforce Development'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078823502',
    brandLogo: null,
    details: `
      <p>Workforce180 and Metrix Learning free 2-day conference.</p>
    `,
  },
  {
    title: 'SkillUpAmerica Summit: Keynote: The Workforce Paradox',
    date: 'April 23, 2025',
    time: null,
    vertical: ['Professional Services', 'Workforce Development'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078823676',
    brandLogo: null,
    details: `
      <p>Workforce180 and Metrix Learning free 2-day conference.</p>
    `,
  },
  {
    title: 'SkillUpAmerica Summit: Pathways to Opportunities',
    date: 'April 23, 2025',
    time: null,
    vertical: ['Professional Services', 'Workforce Development'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078824029',
    brandLogo: null,
    details: `
      <p>Workforce180 and Metrix Learning free 2-day conference.</p>
    `,
  },
  {
    title: 'Best Practices for a Modern Facilities Technician',
    date: 'April 18, 2025',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety', 'Professional Services'],
    topic: [
      'Electrical Skills',
      'HVAC Skills',
      'Mechanical Skills',
      'Industrial Safety and Health',
      'Training Best Practices',
    ],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078808180',
    brandLogo: null,
    details: `
      <p>Join Certus and TPC for this free public one-hour webinar where we will discuss the world of facilities technicians in commercial and industrial buildings. Topics include:</p>
      <ul>
        <li>The importance of facilities technicians and their role in a variety of industries</li>
        <li>Skills and knowledge required for today’s modern facilities technician. HVAC, plumbing, and everything in between</li>
        <li>To specialize or not to specialize? Considerations for training a new facilities technician</li>
      </ul>
    `,
  },
  {
    title: 'The Trouble with Troubleshooting for Plastics Process Technicians',
    date: 'April 11, 2025',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Plastics Process and Operations'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078808753',
    brandLogo: null,
    details: `
      <p>In the world of plastics processing, troubleshooting is a fact of life. Sometimes the fix is easy, but other times, it may not be so simple. Join Certus and Paulson Training for this free public one-hour webinar where we will discuss the unique challenges with troubleshooting for plastics process technicians.</p>
      <p>Most often, initial troubleshooting efforts fall to the molding technician. It often takes years to become a proficient technician, and yet many do not have the experience to guide them. Therefore, a strategic approach to troubleshooting is key. Good processors know this. So, how do you set yourself up to succeed? It’s all in the details.</p>
      <p>In this session, we’ll discuss some of the things that can be done to prepare your facility to meet these troubleshooting challenges when they occur.</p>
    `,
  },
  {
    title: 'Training Challenges for the Construction Industry',
    date: 'February 21. 2025',
    time: null,
    vertical: ['Workplace Safety', 'Workforce Development'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078808928',
    brandLogo: null,
    details: `
      <p>Join Certus and OSHA Education Center for this free public one-hour webinar where we will discuss the training challenges specific to the construction industry. Topics include: </p>
      <ul>
        <li>The chaotic and highly variable nature of construction work environments</li>
        <li>Understanding OSHA standards and statistics specific to construction workers</li>
        <li>How to build a training program specific to different job profiles within a construction site</li>
      </ul>
    `,
  },

  // old recorded webinars
  {
    title: 'Best Practices for Reading Electrical Schematics',
    date: 'December 13, 2024',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078808252',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Reading electrical schematics is a crucial skill for the modern technician. Schematics provide an essential roadmap for the operation of the machines and processes. Join TPC for this free public 1-hour webinar, where we will discuss the following topics:</p>
      <ul>
        <li>How to interpret ladder diagram drawing formats</li>
        <li>How to interpret high-voltage segments of 3-phase circuit schematics</li>
        <li>How to recognize the most common electrical schematic symbols</li>
        <li>Understanding differences between NEMA and IEC schematic formats</li>
      </ul>
    `,
  },
  {
    title: 'Troubleshooting Scenarios Workshop for Maintenance Technicians',
    date: 'October 25, 2024',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills', 'HVAC Skills', 'Mechanical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078809042',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Topics include:</p>
      <ul>
        <li>How to properly select proper Arc-rated Personal Protective Equipment (PPE)</li>
        <li>How to properly read a schematic and relate it to the real-world environment</li>
        <li>How to use a multimeter to systematically troubleshoot a control circuit</li>
        <li>How to navigate a 3-phase motor-operated system</li>
        <li>How to verify a system is properly isolated from energy before proceeding with repairs</li>
      </ul>
    `,
  },
  {
    title: "Wait! - Don't ignore part weight in Injection Molding",
    date: 'August 28, 2024',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Plastics Process and Operations'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078809128',
    brandLogo: null,
    details: `
      <p>Topics include:</p>
      <ul>
        <li>Correlation with part dimensions</li>
        <li>Improve product stability</li>
        <li>Streamline troubleshooting</li>
        <li>Indicator of shift in material viscosity</li>
        <li>Identify process drift</li>
      </ul>
    `,
  },
  {
    title: 'Interactive Simulations for HVAC Troubleshooting',
    date: 'April 5, 2024',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['HVAC Skills', 'Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078808332',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>From April 5, 2024, this webinar's topics include:</p>
      <ul>
        <li>How to identify and inspect key HVAC components in a simulated environment: compressor, condenser, evaporator, and metering device</li>
        <li>How to utilize manifold pressure gauges in a simulated environment</li>
        <li>How to learn quickly about different HVAC scenarios efficiently, by changing factors such as: indoor temperature, outdoor temperature, humidity, CO2 levels, and more</li>
        <li>How to utilize HVAC simulations in your HVAC learning program</li>
      </ul>
    `,
  },
  {
    title: 'Overview of the 2024 NFPA 70E®, Standard for Electrical Safety in the Workplace',
    date: 'January 27, 2023',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety'],
    topic: ['Electrical Skills', 'Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1078808639',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This TPC webinar from February 23, 2024, covered the NFPA 70E Standard for Electrical Safety in the Workplace has been updated for the 2024 code cycle. Watch the 1-hour webinar where we will discuss all of the latest changes. Topics include:</p>
      <ul>
        <li>Updates to general electrical safety work practices, based on industry feedback</li>
        <li>Updates to equipment maintenance requirements</li>
        <li>Updates to special equipment safety work practices</li>
      </ul>
    `,
  },
  {
    title: 'Hazard Avoidance Series: Walking & Working Surfaces',
    date: 'July 27, 2023',
    time: null,
    vertical: ['Workplace Safety'],
    topic: ['Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/1079382137',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This TPC webinar from July 27, 2023, discusses the actionable tips and tricks to avoid one of the most common hazards covered by our OSHA safety courses: walking and working surfaces. Topics of discussion include:</p>
      <ul>
        <li>General Housekeeping</li>
        <li>Floor openings and holes</li>
        <li>Wall openings</li>
        <li>Open-sided floors and platforms</li>
        <li>Stairs and ladders</li>
        <li>Scaffolding</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-f8d21710-0bbb-4f2c-a443-0e1dc497bc67/0/-/-/-/-/Hazard%20Avoidance%20Walking%20Working%20Surfaces%20Webinar%20PDF.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Hazard Avoidance Series: Walking &amp; Working Surfaces</a></p>
    `,
  },
  {
    title: 'How to Use Digital Platforms to Improve your Safety and Compliance Program',
    date: 'May 24, 2023',
    time: null,
    vertical: ['Workplace Safety'],
    topic: ['Industrial Safety and Health', 'Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/o07LugIFf90',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This TPC webinar from May 24, 2023, discusses methods for modernizing your organization's safety and compliance programs. Topics of discussion include:</p>
      <ul>
        <li>Common challenges that modern solutions can improve</li>
        <li>Changes to OSHA's penalty structure and other regulatory updates</li>
        <li>How to smartly switch from paper to digital safety audits and inspections</li>
        <li>How to more consistently view safety performance, and results at a large scale</li>
        <li>How to utilize digital tools to aid in safety decision-making</li>
        <li>A demonstration of TPC's Mobile Audit &amp; Inspections product</li>
      </ul>
    `,
  },
  {
    title: 'Most Impactful Changes in the 2023 National Electrical Code',
    date: 'January 27, 2023',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety'],
    topic: ['Electrical Skills', 'Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/_-LDkx9vuJ4',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This TPC webinar from January 27, 2023, discusses the latest changes to the new 2023 National Electrical Code. Some of the topics covered are:</p>
      <ul>
        <li>Definitions</li>
        <li>Electrical installation requirements</li>
        <li>Equipment sizing requirements</li>
        <li>Other important Code changes</li>
      </ul>
    `,
  },
  {
    title: 'National Safety Month: Chat with the Expert',
    date: 'June 24, 2022',
    time: null,
    vertical: ['Workplace Safety'],
    topic: ['Industrial Safety Health', 'Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/J3KMpKbcQ2Q',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This technical webinar from June 24, 2022, explores the most important safety issues in today's modern workplace. Topics of discussion include:</p>
      <ul>
        <li>What are the latest trends in OSHA standards?</li>
        <li>What are the most common injuries in today's workplace?</li>
        <li>What are the latest trends in improving safety in general industry and construction workplaces?</li>
        <li>How does improved safety translate to a company's financial bottom line?</li>
      </ul>
    `,
  },
  {
    title: 'Understanding the Refrigeration Cycle as an HVAC Technician',
    date: 'March 11, 2022',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['HVAC Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/66ZPJtrjHso',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This technical webinar from March 11, 2022, explores troubleshooting an air conditioning system. One of the most important skills an HVAC technician can have is understanding the refrigeration cycle. In this webinar, we break down the working parts of the refrigeration cycle and how it translates to the operation of an air conditioning system.</p>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-d3f13dc2-cfb0-4603-9311-949a96eaf56d/0/-/-/-/-/Understanding%20the%20Refrigeration%20Cycle%20as%20an%20HVAC%20Technician.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Understanding the Refrigeration Cycle as an HVAC Technician</a></p>
    `,
  },
  {
    title: 'Understanding Multimeter Measurements for Electrical Troubleshooting',
    date: 'March 11, 2022',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/TsFgH4xEcJQ',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This technical webinar from February 11, 2022, explores the readings of an electrical multimeter when doing electrical troubleshooting. We discuss AC and DC voltage readings, Ohm readings, Ampere readings using the amp clamp, and how to interpret their readings when measuring electrical control panels. Does a "0" voltage reading mean the circuit is de-energized? What does "OL" mean on the resistance setting?</p>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-a107a2b8-de06-42ad-aa31-f960a419a272/0/-/-/-/-/Download%20PDF%20for%20How%20to%20Read%20Your%20International%20Style%20Electrical%20Schematics.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Understanding Multimeter Measurements for Electrical Troubleshooting</a></p>
    `,
  },
  {
    title: 'How to Read Your International Style Electrical Schematics',
    date: 'January 14, 2022',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/NxfnbyMZcMY',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Electrical schematics are one of the most important tools for any electrical worker looking to troubleshoot and understand their electrical systems. Having the skills to understand symbols and logic in an electrical diagram can save valuable time and man-hours on the job. This pre-recorded webinar is from January 14, 2022, covers these topics:</p>
      <ul>
        <li>Compare International vs. North American overall schematic features</li>
        <li>Most common electrical schematic symbols</li>
        <li>Power vs. control circuit</li>
        <li>How to troubleshoot using international schematics</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-9cce52ff-254b-4d5e-a6eb-4ceb07536f5d/0/-/-/-/-/How%20to%20Read%20Your%20International%20%28IEC%29%20Style%20Electrical%20Schematics.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for How to Read Your International Style Electrical Schematics</a></p>
    `,
  },
  {
    title: 'Measurement Tools for HVAC Technicians and How to Use Them',
    date: 'December 10, 2021',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['HVAC Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/q3WDMj4Y1yE',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>HVAC technicians use a variety of tools to troubleshoot and understand the operation of the air conditioning systems they work on. This webinar covers some of the most useful tools for an HVAC technician and how to use them. This pre-recorded webinar is from December 10, 2021, covers these topics:</p>
      <ul>
        <li>HVAC pressure gauges</li>
        <li>Temperature measurement devices</li>
        <li>P-T Charts</li>
        <li>Humidity measurement devices</li>
        <li>Other tools of the trade</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-cc6ca629-004d-4e7a-9f40-ca2216bd0676/0/-/-/-/-/Measurement%20tools%20for%20HVAC%20Technicians.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Measurement Tools for HVAC Technicians</a></p>
    `,
  },
  {
    title: 'Hydraulic Systems: What You Need to Know to Troubleshoot',
    date: 'October 22, 2021',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Mechanical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/IqgDDS7x1Gc',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>We know that it is critical to avoid downtime in your facility and this webinar will focus on the most efficient way to troubleshoot issues with your hydraulic systems. Components that make up standard hydraulic systems components to best practices in troubleshooting make this webinar valuable for the entire maintenance team. This pre-recorded webinar is from October 22, 2021, covers these topics:</p>
      <ul>
        <li>Hydraulic principles</li>
        <li>Core components of a hydraulic system</li>
        <li>Safety and maintenance</li>
        <li>Best practices for troubleshooting a hydraulic system</li>
        <li>Most common issues and failures</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-b4fd2c71-facf-4e73-81ab-b95ba571d1da/0/-/-/-/-/Hydraulic%20Systems.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for the Hydraulic Systems</a></p>
    `,
  },
  {
    title: 'The Cycle of Clean Water: "Tap to Toilet and Back"',
    date: 'September 30, 2021',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Mechanical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/bGBwkD3u0z0',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Clean water is essential to our communities and this informative webinar will describe how water flows through our lives. Water is one of the most plentiful resources on the earth but access to clean water is becoming more challenging for many of us. This webinar covers the complete cycle water travels from drinkable water to wastewater and back. This pre-recorded webinar from September 30, 2021, covers these topics:</p>
      <ul>
        <li>What happens when you flush your toilet?</li>
        <li>How does wastewater treatment work?</li>
        <li>How does water flow in the system?</li>
        <li>What do operators do to treat the water we drink?</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-5c68f610-83d0-4201-b74c-253e363d6624/0/-/-/-/-/Cycle%20of%20Clean%20Water.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for The Cycle of Clean Water</a></p>
    `,
  },
  {
    title: "Building Knowledge and Hands-On Skills through Digital Training: What's Possible",
    date: 'September 15, 2021',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/dDumwY-7uXo',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>There are 2 important components of learning for highly technical jobs in today's workplace - building foundational knowledge and developing practical hands-on skills. How can both of these components for learning be delivered in a digital environment? This pre-recorded webinar from September 15, 2021, was co-hosted with Plant Services. We discuss what's possible in the realm of digital hands-on learning, as well as:</p>
      <ul>
        <li>Is it possible to learn "hands-on" in a digital format?</li>
        <li>Methods of learning in a virtual environment; simulations and skills-based activities</li>
        <li>How to adopt a digital troubleshooting curriculum that gives technicians the ability to diagnose and repair machinery quickly, effectively, and safely.</li>
        <li>How effective can digital learning be to solve for safety concerns, machine downtime concerns, time off the floor, etc.</li>
        <li>Real-world scenarios for how organizations utilize digital learning to accomplish learning goals</li>
      </ul>
    `,
  },
  {
    title: 'VFDs and How They Work',
    date: 'August 5, 2021',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/bjOvJdKwFsI',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Variable Frequency Drives (VFDs) are widely used in industrial facilities to control the operation of motors. Join TPC for this complimentary, 1-hour public webinar about how VFDs operate. This pre-recorded webinar from August 5, 2021 includes these topics:</p>
      <ul>
        <li>The main components of a VFD</li>
        <li>Applications and uses of a VFD</li>
        <li>Common concerns during VFD operation</li>
        <li>VFD maintenance best practices</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-9cde40bb-5b9d-4616-a47d-d751036aa2b5/0/-/-/-/-/VFDs%20and%20How%20They%20Work%20Webinar%20PDF.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for VFDs and How They Work</a></p>
    `,
  },
  {
    title: 'Electrical Safety and How to Establish an Electrically Safe Work Condition',
    date: 'July 8, 2021',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety'],
    topic: ['Electrical Skills', 'Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/_OAXVOL9S6w',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Variable Frequency Drives (VFDs) are widely used in industrial facilities to control the operation of motors. Join TPC for this complimentary, 1-hour public webinar about how VFDs operate. This pre-recorded webinar from August 5, 2021 includes these topics:</p>
      <ul>
        <li>The 8 steps laid out in Article 120 of NFPA 70E standard</li>
        <li>Best practices for lockout/tagout</li>
        <li>What is "stored" energy and how to release it</li>
        <li>Using a multimeter to verify a circuit is de-energized</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-76dd4b20-b316-4005-8174-b143e863e1b7/0/-/-/-/-/Electrical%20Safety%20Webinar%20PDF.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Electrical Safety and How to Establish an Electrically Safe Work Condition</a></p>
    `,
  },
  {
    title: 'Fuses and Circuit Breakers: What you Need to Know',
    date: 'July 8, 2021',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/9lGTGbCQFnY',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Virtually all electrical circuits in today's world have fuses and circuit breakers, but their role in electrical circuits often go unnoticed. This pre-recorded 1-hour public webinar is from July 8, 2021, and discusses:</p>
      <ul>
        <li>What are fuses and circuit breakers designed to protect?</li>
        <li>What to do if a fuse blows/circuit breaker trips. And why?</li>
        <li>Understanding current and interrupting ratings of fuses and circuit breakers</li>
        <li>Testing fuses and circuit breakers are working properly using a multimeter</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-9fd3a7c1-45af-4727-a818-4b612bd28fa9/0/-/-/-/-/Fuses%20and%20Circuit%20Breakers%20Webinar%20PDF.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Fuses and Circuit Breakers: What You Need to Know</a></p>
    `,
  },
  {
    title: 'Systematic Approach to Troubleshooting an HVAC System',
    date: 'June 3, 2021',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['HVAC Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/XaOhjC-IyOo',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>When air conditioning and refrigeration systems are not cooling properly, it is important for the HVAC technician to get it up and running quickly and efficiently. Join TPC for this free 1-hour public webinar all about the systematic approach for troubleshooting HVAC systems. Topics include:</p>
      <ul>
        <li>Understanding temperature and pressure readings</li>
        <li>Determining superheating and subcooling and interpreting results</li>
        <li>Common scenarios and how to fix them</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-7e3fb18c-4ebe-4341-b659-aa9ab3d71fc0/1/-/-/-/-/Systematic%20Approach%20to%20Troubleshooting%20an%20HVAC%20System.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Systematic Approach to Troubleshooting an HVAC System</a></p>
    `,
  },
  {
    title: 'What is 3-Phase Electrical Power?',
    date: 'May 6, 2021',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/XZ5WlWfAyoE',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>The term "3-phase" is used often in commercial and industrial applications, but the term is commonly misunderstood. Join TPC for this free public 1-hour webinar, where we will break down 3-phase power and how it works. Topics discussed include:</p>
      <ul>
        <li>Why do we use 3-phase power in today's society? What are its benefits?</li>
        <li>How is 3-phase power transmitted and conducted through cities and facilities?</li>
        <li>How to understand multimeter readings on wires in a 3-phase electrical panel</li>
        <li>A brief overview of 3-phase terminologies, such as power factor and kVA ratings</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-b026cf5d-6d19-4e2c-8808-92ff0ac5232f/1/-/-/-/-/What%20is%203%20Phase%20Power.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for What is 3-Phase Power?</a></p>
    `,
  },
  {
    title: 'Understanding How to Read a Pump Curve',
    date: 'April 8, 2021',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Mechanical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/tEsV9Q6q3w4',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>When understanding the specifications of a pump, it's important to understand how to read a pump curve and its application to your operation. Join TPC for this free public 1-hour webinar about how to read and interpret pump curves. Topics discussed include:</p>
      <ul>
        <li>Breakdown of terminology seen in a pump curve: HP, GPM, pump head, efficiency, etc.</li>
        <li>Understanding the relationship between different specifications on the pump curve</li>
        <li>Running a few scenarios with assessing pumps based on its pump curve</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-eb444026-ee10-4cce-bd6a-3285909bbf7b/1/-/-/-/-/How%20to%20Read%20a%20Pump%20Curve.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for How to Read a Pump Curve</a></p>
    `,
  },
  {
    title: 'Fundamentals of Solar Photovoltaic Systems',
    date: 'March 25, 2021',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/px239v5o6xU',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Join TPC for this free public 1-hour webinar about the basics of solar photovoltaic systems for commercial and residential use. In this session we will discuss:</p>
      <ul>
        <li>The process of converting the sun's energy to electrical energy</li>
        <li>Understanding amps, volts, watts, and efficiency in the perspective of solar installations</li>
        <li>Overview of best practices for maintenance and care of solar photovoltaic panels</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-ddfe7985-823e-47c3-a5ff-3c8d2acbee74/1/-/-/-/-/Fundamentals%20of%20Photovoltaic%20Systems.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Fundamentals of Solar Photovoltaic Systems</a></p>
    `,
  },
  {
    title: 'Understanding Generator Ratings and Safety Labeling',
    date: 'March 11, 2021',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Mechanical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/WOrsP-XPswQ',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Join TPC for this free public 1-hour webinar about how to properly interpret the ratings of your generator's nameplate as well as important safety labeling found on generators. In this session we will discuss:</p>
      <ul>
        <li>Understanding the unique manufacturer codes a generator nameplate contains.</li>
        <li>Detailed explanation of mandated information on the generator nameplate.</li>
        <li>Discuss other important safety labels provided by the manufacturer.</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-831ed52a-f70f-4d76-8651-fdbb39cec11b/1/-/-/-/-/Understanding%20Generator%20Ratings%20and%20Safety%20Labeling.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Understanding Generator Ratings</a></p>
    `,
  },
  {
    title: 'Intro to PLC Programming',
    date: 'February 25, 2021',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/diIVc1nrGKI',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Join TPC Training on this complimentary webinar as we introduce some of the principles and rules to follow in programming Programmable Logic Controllers (PLCs).</p>
    `,
  },
  {
    title: 'Understanding How a Boiler Works: The Basics',
    date: 'February 11, 2021',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['HVAC Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/z9elO4_E5-0',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Many commercial and industrial organizations operate boilers in their buildings. It's important for the organization to have a grasp of how their boiler systems work so they can maintain and troubleshoot them. Join TPC Training for this free public webinar as we discuss the fundamentals of a boiler system. We will discuss:</p>
      <ul>
        <li>Breakdown of the basic working components of a boiler system</li>
        <li>Understanding boiler terminology</li>
        <li>Understanding how steam flows in a system</li>
        <li>Different types of boilers</li>
      </ul>
    `,
  },
  {
    title: 'OSHA Injury & Illness Annual Recordkeeping Criteria for 2020',
    date: 'January 28, 2021',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety'],
    topic: ['Industrial Safety and Health', 'Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/QzilUkEjZw8',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Once again it's time for employers to compile their injury and illness data in accordance with OSHA's recordkeeping compliance requirements. Does your company fall under these mandates and do you know what specific information you are required to record and report? This webinar will address the following topics:</p>
      <ul>
        <li>Overview of OSHA's 1904 recordkeeping regulation</li>
        <li>Severe injury reporting requirements</li>
        <li>Completion and maintenance of OSHA 300, 300A &amp; 301 forms</li>
        <li>Electronic submission of records</li>
        <li>COVID-19 guidance</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-30348c68-a8e9-4f8d-8950-15ef7beb2bea/1/-/-/-/-/OSHA%20Injury%20and%20Illness%20Annual%20Recordkeeping%20Criteria.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for OSHA Injury & Illness Annual Recordkeeping Criteria for 2020</a></p>
    `,
  },
  {
    title: 'The 2021 NFPA 70E Standard: Highlight of the Changes',
    date: 'January 14, 2021',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety'],
    topic: ['Electrical Skills', 'Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/urp6a-YQ_9o',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>The new NFPA 70E standard is here. Since NFPA 70E applies to all individuals working on electrical circuits, it is very important to be kept aware of changes. Join TPC Training for this free public webinar where we will give an overview of some of the changes in the standard in preparation for your next official electrical safety training class.</p>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-e278ffaa-5387-46a7-abba-9bf2d3b7c30a/1/-/-/-/-/2021%20NFPA%2070E%20-%20Highlight%20of%20Changes.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for The 2021 NFPA 70E Standard: Highlight of the Changes</a></p>
    `,
  },
  {
    title: 'Crash Course On How To Read Electrical Schematics',
    date: 'December 17, 2020',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/Et-gHKTdziU',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Electrical schematics are one of the most important tools for any electrical worker looking to troubleshoot and understand their electrical systems. Having the skills to understand symbols and logic in an electrical diagram can save valuable time and man-hours on the job. Join TPC Training for this free public webinar crash course on electrical schematics on how to read them. We will discuss:</p>
      <ul>
        <li>Common electrical schematic symbols</li>
        <li>Overview of electrical terminology</li>
        <li>Understanding Normally Open vs. Normally Closed on a schematic</li>
        <li>Review of European vs. North American schematic features</li>
        <li>Introduction to ladder diagrams for control circuits</li>
        <li>Using technology to gain hands-on experience in a virtual environment</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-a694e43d-33df-45f9-9087-044008ea3733/1/-/-/-/-/Crash%20Course%20on%20How%20to%20Read%20Electrical%20Schematics.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Crash Course On How To Read Electrical Schematics</a></p>
    `,
  },
  {
    title: 'How to Train Outside of the Classroom: On-the-job and Machine-specific Training in the 21st Century',
    date: 'December 3, 2020',
    time: null,
    vertical: ['Industrial Skills', 'Professional Services'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/xxztjIKoif4',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>It's important to remember that learning does not end when you leave the training classroom! In today's 21st-Century environment, technicians have access to more information and support systems outside of the classroom than ever before. Join TPC Training during this free public webinar, where we will discuss the best ways for technicians to continue learning throughout their careers. We will discuss:</p>
      <ul>
        <li>Using centralized platforms to troubleshoot and train on machines</li>
        <li>Using electronic forms for on-the-job training and skills verification</li>
        <li>Microlearning at the moment of need</li>
        <li>Using technology to gain hands-on experience in a virtual environment</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-167f6f55-b9dd-4647-93b2-7e26253e9e61/1/-/-/-/-/How%20to%20Train%20Outside%20the%20Classroom.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for How to Train Outside of the Classroom</a></p>
    `,
  },
  {
    title: 'How to Use Blended Learning in a Constantly Changing Workplace',
    date: 'November 19, 2020',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/ubwPOPsMEvM',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>When it comes to building technical skills, different people learn in different ways. And in many cases, the conditions of our workplace may compel us to consider more flexible learning options for our employees. What's the right mix of formal learning, on-the-job learning, and skills verification? How can these be delivered reliably? In this free public webinar, join TPC Training as we discuss how to build a training path that can address different learning styles, but also offer flexibility for times and locations.</p>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-fc4212b0-0959-44be-a5b7-ecf57f335db1/1/-/-/-/-/How%20to%20Use%20Blended%20Learning%20in%20a%20Constantly%20Changing%20Workplace.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for How to Use Blended Learning in a Constantly Changing Workplace</a></p>
    `,
  },
  {
    title:
      'Where Troubleshooting and Training Come Together: Using Software to Efficiently Understand Machines and Processes',
    date: 'November 5, 2020',
    time: null,
    vertical: ['Industrial Skills', 'Professional Services'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/zDcrcELQeQY',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>When troubleshooting a machine or process that has broken down, many organizations struggle to quickly find issues and address them, resulting in long periods of costly downtime. Similarly, when training on-the-job, technicians rarely document best practices when passing knowledge to their colleagues. Thankfully, there are software solutions available in the 21st century that can streamline how we troubleshooting and train on our machines. Join TPC Training on this free public webinar as we discuss how to use software to:</p>
      <ul>
        <li>Locate and interact with machine schematics in real-time</li>
        <li>Find part numbers, settings, and specs on any machine component in real-time</li>
        <li>Pinpoint areas for troubleshooting quickly and efficiently</li>
        <li>Onboard new technicians quickly on the operation of the machine or process</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-975ddae1-8656-4c17-98f5-d80a06dcc805/1/-/-/-/-/Where%20Troubleshooting%20and%20Training%20Come%20Together.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for When Training and Troubleshooting Come Together</a></p>
    `,
  },
  {
    title: 'The Systematic Approach to Troubleshooting',
    date: 'October 22, 2020',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills', 'HVAC Skills', 'Mechanical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/oVctP35xxQY',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>The term "troubleshooting" is a central part of almost any technical career, whether it be maintenance, operations, or engineering. However, the process of troubleshooting can vary greatly from place to place. Join TPC Training on this free public webinar as we discuss a systematic troubleshooting approach that can be used any time you troubleshoot, regardless of whether it's on electrical systems, mechanical systems, HVAC, or operational. We will discuss:</p>
      <ul>
        <li>What are the key things to think about when troubleshooting?</li>
        <li>What are some common mistakes made during the troubleshooting process?</li>
        <li>What steps can we take without needing to exposed to hazards?</li>
        <li>Some applications of the troubleshooting process</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-5fcd3b7d-c429-4e28-a462-8dcf632535c8/1/-/-/-/-/The%20Systematic%20Troubleshooting%20Approach.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for The Systematic Approach to Troubleshooting</a></p>
    `,
  },
  {
    title: 'Enhanced Workforce Development with TPC Fusion',
    date: 'October 8, 2020',
    time: null,
    vertical: ['Workforce Development'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/AXiHrvK2ssE',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>TPC Training is proud to unveil TPC Fusion, our brand-new comprehensive workforce management platform. Join us for a free public webinar session where we will discuss the new features of our system and what it can do to drive training and performance within your organization. Topics include:</p>
      <ul>
        <li>Setting up robust customized training programs for employees</li>
        <li>Supervising on-the-job training as well as classroom training progress</li>
        <li>Utilizing mobile forms for workplace inspections and skills verification</li>
        <li>Managing contractors in real-time</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-0fba6a9e-baff-41f7-8fde-35772a1f0219/1/-/-/-/-/Enhanced%20Workforce%20Management%20with%20TPC%20Fusion.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Enhanced Workforce Development with TPC Fusion</a></p>
    `,
  },
  {
    title: 'Measurement Tools for HVAC Technicians and How to Use Them',
    date: 'September 17, 2020',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['HVAC Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/NxXmqbp2qug',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>HVAC technicians use a variety of tools to troubleshoot and understand the operation of the air conditioning systems they work on. Join TPC Training for this free public webinar that will cover some of the most useful tools for an HVAC technician and how to use them. We will discuss:</p>
      <ul>
        <li>HVAC pressure gauges</li>
        <li>Temperature measurement devices</li>
        <li>P-T Charts</li>
        <li>Humidity measurement devices</li>
        <li>Other tools of the trade</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-6a12a727-87a9-4769-a63f-6f4b4342ef20/1/-/-/-/-/HVAC%20Tools.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Measurement Tools for HVAC Technicians and How to Use Them</a></p>
    `,
  },
  {
    title: 'Learning Electrical Troubleshooting in a Virtual Environment',
    date: 'September 10, 2020',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills', 'Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/q3a2FeaZ6RM',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>How can electrical workers practice electrical troubleshooting, without putting themselves at risk of electrical shock as they learn the basics? Join TPC Training for this free public webinar where we discuss how to test electrical troubleshooting skills in a virtual environment where mistakes can be made and lessons can be learned in a safe and convenient environment. We will discuss:</p>
      <ul>
        <li>The details of the virtual electrical troubleshooting environment</li>
        <li>How to systematically test voltage inside of an electrical panel, within the virtual environment</li>
        <li>How to find faults in an electrical system, using the virtual environment</li>
        <li>What the future holds for technical training in a virtual environment</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-784cf0b7-8173-4418-9e7c-a1be93057d14/1/-/-/-/-/Learning%20Electrical%20Troubleshooting%20in%20a%20Virtual%20Environment.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Learning Electrical Troubleshooting in a Virtual Environment</a></p>
    `,
  },
  {
    title: '2021 NFPA 70E Changes: A Live Discussion',
    date: 'August 20, 2020',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety'],
    topic: ['Electrical Skills', 'Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/DYp9pyDgSwE',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>The 2021 version of the NFPA 70E Standard for Electrical Safety in the Workplace will be released this year. Join TPC Training for a free public live panel discussion with electrical experts as we discuss the latest changes to the NFPA 70E standard. We will discuss:</p>
      <ul>
        <li>The details of the virtual electrical troubleshooting environment</li>
        <li>How to systematically test voltage inside of an electrical panel, within the virtual environment</li>
        <li>How to find faults in an electrical system, using the virtual environment</li>
        <li>What the future holds for technical training in a virtual environment</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-ea202c6d-cb8f-42ac-bffc-bd46a5eb6128/0/-/-/-/-/NFPA%2070E%202021%20Changes%20-%20A%20Live%20Discussion%20-%20English.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for 2021 NFPA 70E Changes</a></p>
    `,
  },
  {
    title: '[In Spanish] 2021 NFPA 70E Changes: A Live Discussion',
    date: 'August 20, 2020',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety'],
    topic: ['Electrical Skills', 'Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/HNPKKfySVns',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>La versión 2021 de la norma NFPA 70E para seguridad eléctrica en el lugar de trabajo se lanzará este año. Únase a TPC Training para una discusión pública gratuita del panel en vivo con expertos en electricidad mientras discutimos los últimos cambios a la norma NFPA 70E. Con una tematica de:</p>
      <ul>
        <li>Lo más destacado de los cambios en el 2021 NFPA 70E</li>
        <li>Concepto básico para que cualquier trabajador del rubro electrico entienda NFPA 70E</li>
        <li>Descripción general de las últimas pautas de protección contra los riesgos de la electricidad para los trabajadores y EPP</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-73f8569d-940f-4fb4-aad6-990d5fb35a9e/0/-/-/-/-/NFPA%2070E%202021%20Changes%20-%20A%20Live%20Discussion%20-%20Spanish.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Descargar PDF para los cambios de NFPA 70E de 2021</a></p>
    `,
  },
  {
    title: 'Building a Maintenance Training Program at Your Facility: Where Do You Start?',
    date: 'August 13, 2020',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/aM0pcGO66Ag',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>It's difficult to make room for training, especially in a fast-paced, constantly-changing maintenance environment. While building knowledge and skills in the maintenance department is always a goal at an organization, it's sometimes difficult to implement this vision. This free webinar discusses some good first steps in rolling out a strong and lasting maintenance training program. Items discussed:</p>
      <ul>
        <li>What are some good foundations to have before rolling out a training program?</li>
        <li>What documentation is recommended for a strong program?</li>
        <li>How can organizations make training programs lasting and sustainable?</li>
        <li>How do we know whether the training program is effective?</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-c756740b-6351-4c2c-8231-4ddfdbdb95d3/0/-/-/-/-/Building%20a%20Maintenance%20Training%20Program%20at%20Your%20Facility.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Building a Maintenance Training Program at Your Facility</a></p>
    `,
  },
  {
    title: 'Falls and Electrical Hazards: The Double Dangers of Maintenance',
    date: 'July 22, 2020',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety'],
    topic: ['Electrical Skills', 'Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/obSsBXr2Nsg',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Maintenance activities and personnel who perform them are exposed to numerous workplace hazards that can lead to severe injuries and death. Among them, falls and electrical hazards present their own unique challenges regarding hazard recognition, mitigation, and training. Beyond regulatory compliance, there are specific industry consensus standards that can guide employers through the many challenges of developing and implementing effective fall protection and electrical safety programs, and clearly define common roles and requirements associated with those programs.</p>
      <p>This presentation was co-hosted by PlantServices and was presented by Paul Colangelo, STSC, CHST, CIT, CRIS, President, PJC Safety Services, LLC.</p>
      <p>Topics include:</p>
      <ul>
        <li>Common workplace hazards</li>
        <li>Regulatory compliance</li>
        <li>Industry consensus standards</li>
        <li>Training programs</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-3a10ddca-1d0f-4448-8ed1-1398ada1f9f7/0/-/-/-/-/Plant%20Services%3A%20Double%20Danger%20Webinar%20Slides.pptx" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Falls and Electrical Hazards</a></p>
    `,
  },
  {
    title: 'Understanding the Refrigeration Cycle as an HVAC Technician',
    date: 'July 16, 2020',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['HVAC Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/ew76m7jf6DA',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>When troubleshooting an air conditioning system, one of the most important skills an HVAC technician can have is understanding the refrigeration cycle. In this webinar, we break down the working parts of the refrigeration cycle and how it translates to the operation of an air conditioning system. Topics discussed includes:</p>
      <ul>
        <li>Core components of the refrigeration cycle and their location</li>
        <li>Understanding of heat transfer throughout the air conditioning system</li>
        <li>Understanding the relationship between temperature and pressure</li>
        <li>Understand the terms of superheat and subcooling</li>
        <li>Best practices for troubleshooting an air conditioning system, using an understanding of the refrigeration cycle</li>
      </ul>
      <p><a href="https://info.tpctraining.com/acton/attachment/4937/f-6977a60b-f8cc-431f-beb3-d8a80aa98280/0/-/-/-/-/Understanding%20the%20Refrigeration%20Cycle%20as%20an%20HVAC%20Technician.pdf" target="_blank" rel="noreferrer" aria-label="link opens in new tab">Download PDF for Understanding the Refrigeration Cycle as an HVAC Technician</a></p>
    `,
  },
  {
    title: '5 Best Practices for Managing Contractor Safety and Reducing Risk',
    date: 'June 25, 2020',
    time: null,
    vertical: ['Workplace Safety', 'Workforce Development'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/433749807',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Many organizations rely on outside contractors to perform onsite functions and responsibilities. While there are benefits to working with contractors, there are also risks if they aren't managed properly. Attend this webinar to understand why contractors present unique challenges, and how to proactively plan for a safe and productive environment. Information covered in this webinar will include:</p>
      <ul>
        <li>OSHA expectations and work-related incidents</li>
        <li>Unique facility limitations and processes</li>
        <li>Technology tools and how they reduce risk</li>
      </ul>
    `,
  },
  {
    title: 'Understanding Multimeter Measurements for Electrical Troubleshooting',
    date: 'June 11, 2020',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/MJsTpQgGFKc',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>In this technical webinar, TPC Training explores the readings of an electrical multimeter when electrical troubleshooting. In this webinar, we discuss AC and DC voltage readings, Ohm readings, and Ampere readings using the amp clamp, and how to interpret their readings when measuring electrical control panels. Does a "0" voltage reading mean the circuit is de-energized? What does "OL" mean on the resistance setting?</p>
    `,
  },
  {
    title: 'Blending Self-guided and Virtual Instructor-led Training for Enhanced Digital Learning',
    date: 'May 28, 2020',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/5vI9Di3PJik',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Organizations may often face the challenge of training their employees remotely through a computer or internet connection. How can organizations maximize learning and retention and create a comprehensive training program using only digital computer-based formats? How can supervisors track the progress of multiple employees with different job roles? In this free public webinar, we will discuss how to build a training program by blending two formats used in digital training: Self-guided training, and virtual instructor-led training. We will discuss the differences in the formats and how to utilize their differences to create a robust learning experience for employees.</p>
    `,
  },
  {
    title: 'Building Skills in Virtual Training Through Interactive Activities',
    date: 'May 14, 2020',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/yQLJQRAtuao',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Building real-world skills is one of the highest priorities for organizations looking to provide technical training to their employees. Is it possible to build skills in the virtual online format? This webinar explains interactive activities that can be used in the virtual format to build skills for technical trades, such as Electrical, HVAC, and Mechanical professions. Topics include interactive troubleshooting activities, table-top equipment exercises, screen remote control exercises, and methods for promoting interactive discussion.</p>
    `,
  },
  {
    title: 'Best Practices in Virtual Training - A Live Panel Discussion',
    date: 'April 30, 2020',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/ItoN8RhfkwU',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Is it possible to hold intensive training over the internet for such highly technical topics as electrical, mechanical, or HVAC maintenance? How can hands-on skills such as troubleshooting, safety, or meter measurement be developed in a remote online environment? Please join TPC's panel of experts, as they discuss the latest in technical training in the new era of remote learning.</p>
    `,
  },
  {
    title: 'Training Needs Evaluation (TNE) in Your Workplace',
    date: 'April 23, 2020',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety', 'Professional Services'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/411433164',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Sometimes organizations can find themselves in a situation where their training program needs an overhaul. Or, they may have never had a formal training program in place and need help developing a plan. In many cases, the path forward can be unclear. This webinar defines a Training Needs Evaluation (TNE), and how it can benefit your organization. The webinar explains what the TNE process looks like, who needs to be involved, and how long it takes.</p>
    `,
  },
  {
    title: 'Best Practices for Skills Verification in your Workplace',
    date: 'March 19, 2020',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/oS-Nu_PxGRo',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Many jobs throughout the industry require specialized skills, many of them very technical in nature. These skills can make or break the productivity and effectiveness of a company. It's important for organizations to verify that classroom, online, and on-the-job training achieves its goal of gaining these critical skills. The goal of this webinar is to discuss the best practices for skills verification, and the different forms that skills verification can take.</p>
    `,
  },
  {
    title: 'Annual EHS Housekeeping - Is Your Company in Compliance?',
    date: 'February 20, 2020',
    time: null,
    vertical: ['Workplace Safety'],
    topic: ['Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/b7MC1lShdxg',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This webinar focuses on company compliance for EHS and making sure you're company is up to date.</p>
    `,
  },
  {
    title: 'Building a Qualified HVAC Technician Program at your Facility',
    date: 'January 16, 2020',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['HVAC Skills', 'Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/fCefbpRVWvU',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>What does it take to be a "qualified person" to perform HVAC technician work in your facility? How do you know if you're qualified? And who determines whether you or your employees are qualified to do HVAC Technician work in your facility? The purpose of this public webinar session to breakdown what it means to be qualified and how to set up a program for qualified HVAC technicians in your facility.</p>
    `,
  },
  {
    title: 'Building a Qualified Electrical Worker Program at your Facility',
    date: 'December 12, 2019',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills', 'Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/Tusw75be2cw',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This webinar breaks down what it means to be qualified and how to set up a program for qualified electrical workers in your facility.</p>
    `,
  },
  {
    title: 'Effective Safety Culture: Why Contractor Inclusion Matters',
    date: 'October 24, 2019',
    time: null,
    vertical: ['Workplace Safety', 'Workforce Development'],
    topic: ['Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/qmtE8gbFO1I',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This webinar focuses on the critical points of contractor and temp worker inclusion into an effective company safety culture.</p>
    `,
  },
  {
    title: 'Using On the Job Training to Verify your Training Investment',
    date: 'October 3, 2019',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/yga1A4BFOtI',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>After classroom training has been completed, how can you verify that your employees have learned the valuable skills they need to succeed in their jobs? This webinar will discuss the best practices for structuring an on-the-job training (OJT) program that can verify the skills and knowledge gained during classroom training. We will discuss how mobile technology can assist with OJT in the 21st century.</p>
    `,
  },
  {
    title: '2020 National Electrical Code Webinar: Chat with the Experts',
    date: 'September 26, 2019',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety'],
    topic: ['Electrical Skills', 'Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/bqTgmWSm_RY',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This free public webinar is dedicated to answering your questions about the 2020 National Electrical Code being released this year. What changes are included this year? Will certain changes apply to your workplace? What are some of the new electrical installation requirements? Tune in to this free public webinar to interact with our live panel of experts and get your questions answered!</p>
    `,
  },
  {
    title: 'The Benefits of Mobile Forms for EHS Programs',
    date: 'August 14, 2019',
    time: null,
    vertical: ['Workplace Safety'],
    topic: ['Training Best Practices', 'Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/uv0PbMQvJrA',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Environmental Health & Safety (EHS) program documents are a critical element of any employer EHS program. However, documentation, disorganization, or lack of records can be a critical point of gap failure. The pitfalls of using paper documentation for critical programs often cause confusion for employers in sorting out what is required and beneficial. In this webinar, you will learn how mobile form software assists in organizing and adding value for your organization in solving these common issues of running an EHS program.</p>
    `,
  },
  {
    title: 'Electric Motors - Troubleshooting & Understanding',
    date: 'August 2, 2019',
    time: null,
    vertical: ['Workplace Safety'],
    topic: ['Electrical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/390nOrLHAaw',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This webinar is all about electric motors and how to get a better understanding of them. We'll work through some very basic troubleshooting techniques and work through some of the common problems you may face.</p>
    `,
  },
  {
    title: '5 Ways Mobile Forms Can Accelerate Performance & Productivity Webinar',
    date: 'June 5, 2019',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/y8_tpeI7Pn4',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Mobile Forms can super-charge your data collection, reporting accuracy, and ability to identify trends. See how mobile forms can deliver online and offline access to critical operational documentation and can provide real-time data aggregation and reporting on safety, compliance, time, and quality KPI's.</p>
    `,
  },
  {
    title: 'Basics of Pump Repair Maintenance',
    date: 'April 19, 2019',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Mechanical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/nZloA2CUBuk',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This 1-hour webinar looks at the basics of pump repair and maintenance. TPC Training instructor Wade Heisler guides you through some common troubleshooting techniques and how to keep your pumps running smoothly. He'll also take your questions.</p>
    `,
  },
  {
    title: 'HAZWOPER Training - Is it Right For Your Facility',
    date: 'April 3, 2019',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/Nf9yiO6x9oo',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Do you know if your workforce needs Hazardous Waste Operator (HAZWOPER) training? What worksites require the certification? Is your certification expired? TPC Training's HAZWOPER certification and training expert will outline these requirements and help you know "when", "what", "where", and "how" to make sure you and your team are OSHA compliant.</p>
    `,
  },
  {
    title: 'Value of Blended Curriculum Training',
    date: 'March 20, 2019',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/2N9Icx4zLDQ',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>There are a lot of options to get your employees trained, but which is right for you? TPC Training's Ryan Smith guides you through different training formats and how employees learn. You'll have a better understanding of how to make the most of your training budget and the time you have to train employees.</p>
    `,
  },
  {
    title: 'Variable Frequency Drives',
    date: 'October 29, 2018',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/arhLYQJKDrk',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>VFDs are a huge part of any facility. Combining electrical and mechanical technologies as well as software, VFDs provide a little bit of everything. This webinar introduces you to the basics of VFD.</p>
    `,
  },
  {
    title: 'Programmable Logic Controllers',
    date: 'September 21, 2018',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/Fo0wLdJMicI',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>We review the basics of PLCs often referred to the beating heart of any manufacturing facility.</p>
    `,
  },
  {
    title: 'Systematic Troubleshooting',
    date: 'August 10, 2018',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills', 'HVAC Skills', 'Mechanical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/fqcC42t_7Ts',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This webinar is all about troubleshooting. We'll discuss troubleshooting strategies for both electrical and mechanical problems as well as discussing tips and tricks and helpful advice.</p>
    `,
  },
  {
    title: 'Advances in PPE For Electrical Safety',
    date: 'July 13, 2018',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety'],
    topic: ['Electrical Skills', 'Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/8hQ2BYSNWAw',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This second part of our 2 part electrical safety webinar series focuses on personal protective equipment (PPE). We'll take a deeper dive into the types of gear you should be using in different tasks.</p>
    `,
  },
  {
    title: 'Electrical Safety Planning and Techniques, including Arc Flash',
    date: 'June 22, 2018',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety'],
    topic: ['Electrical Skills', 'Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/GalAkY2TvXQ',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>In this webinar, the first of a 2 part series looking closely at electrical safety, we'll dive into planning and techniques to be used to mitigate electrical accidents. We'll take a look at arc flash analysis also. This is a great webinar for anyone trying to proactively avoid electrical accidents before they happen and keep their employees safe.</p>
    `,
  },
  {
    title: 'The Hidden Value of Maintenance and Measuring Training Effectiveness',
    date: 'May 18, 2018',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/ZESlFaSD_no',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>In this webinar, TPC Training Instructor Kurt Brizendine examines basic maintenance fundamentals including the hidden value of maintenance i.e. is training a cost or an investment? We'll discuss general maintenance practices and highlight some troubleshooting basics.</p>
    `,
  },
  {
    title: 'An Overview of the Latest NEC Changes',
    date: 'May 16, 2018',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety'],
    topic: ['Electrical Skills', 'Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/SzNQLivoP6s',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>The National Electrical Code changes every 3 years and managing that change can be challenging to facilities and buildings. This 1 hour webinar highlights some of the major changes in the most recent code change and discusses how it can affect your facility.</p>
    `,
  },
  {
    title: 'How Performance Support Changes the Game for Operator Training',
    date: 'April 26, 2018',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://player.vimeo.com/video/287461669',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>In this webinar, TPC dives into the issue of operator support. the session explores how information needs to be at least 3 clicks or 10 seconds away to be affective towards supporting machine operator issues and maintenance.</p>
    `,
  },
  {
    title: 'Basics of Standby Generators and Emergency Power',
    date: 'February 16, 2018',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/wH9-HJN2jBk',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Power outages are often not the fault of the facility but still happen. Local construction mistakes and weather can have an adverse effect on your facility and your customers. This webinar will help you understand how to mitigate the hassles involved in power outages, what you can do to provide backup emergency power and we'll introduce you to uninterruptible power supply systems.</p>
    `,
  },
  {
    title: 'Solar Power Basics',
    date: 'January 19, 2018',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Electrical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/1ZWIyH7tRmM',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Utilizing renewable energy sources can be a great opportunity for facilities to cut costs. At the forefront of that is photovoltaic energy aka solar power. But there are unique challenges related to that. TPC Trainco instructor and electrical engineer Ryan Smith will guide you through the basics of solar power and the unique challenges it presents.</p>
    `,
  },
  {
    title: 'Controlling Maintenance Resources',
    date: 'December 11, 2017',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/eYFKWVbdzYE',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>This one hour webinar will look at achieving cost reductions by utilizing resources more efficiently and reducing downtime. We'll examine 5-S methodology, total productive maintenance, process and equipment effectiveness, and basics of planning and scheduling. TPC Trainco instructor Brett Smith will guide you through making sure you have the knowledge needed to get started.</p>
    `,
  },
  {
    title: 'Basic Pump Maintenance Strategies & Techniques',
    date: 'July 26, 2017',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['Mechanical Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/v5lPyNSYGK8',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Join our webinar as Wade Heisler, TPC Training instructor, has he dives into maintenance technicians' responsibilities for pump specification, installation, and operating efficiency at their facility.</p>
    `,
  },
  {
    title: 'Life after an OSHA Violation',
    date: 'April 27, 2017',
    time: null,
    vertical: ['Workplace Safety'],
    topic: ['Industrial Safety and Health', 'Training Best Practices'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/9WWfdvYRe5A',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Join our webinar that breaks down what to do after getting a citation from The Occupational Safety and Health Administration (OSHA) because it isn't the end of the world.</p>
    `,
  },
  {
    title: 'Arc Flash Analysis and NFPA 70E Compliance',
    date: 'June 9, 2016',
    time: null,
    vertical: ['Industrial Skills', 'Workplace Safety'],
    topic: ['Electrical Skills', 'Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/7n4szbz4T1Y',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Examine the basics of arc flash analysis in this handy webinar.</p>
    `,
  },
  {
    title: 'How to Avoid OSHA Violations',
    date: 'May 25, 2016',
    time: null,
    vertical: ['Workplace Safety'],
    topic: ['Industrial Safety and Health'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/o5VtINBoSGo',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Take a look at our webinar as Bob Clukey walks through common OSHA violations that facilities face & tips to avoid them.</p>
    `,
  },
  {
    title: 'Boiler Safety, Operation and Procedures',
    date: 'September 21, 2015',
    time: null,
    vertical: ['Industrial Skills'],
    topic: ['HVAC Skills'],
    registrationUrl: null,
    id: null,
    recordingUrl: 'https://www.youtube.com/embed/lsiJiYrey0A',
    brandLogo: 'TPC-logo.png',
    details: `
      <p>Join our webinar as our TPC training instructor Tim McDaniel guides us through the basics of boiler operation safety.</p>
    `,
  },
];

export default {
  webinars,
};
